"use client";

import { ComponentType, useEffect, useState } from "react";

import { Skeleton } from "@/components/ui/Skeleton";

type PortfolioPreviewProps = { lightSurface?: boolean };

export function LazyPortfolioPreview(props: PortfolioPreviewProps) {
  const [Preview, setPreview] =
    useState<ComponentType<PortfolioPreviewProps> | null>(null);

  useEffect(() => {
    let isMounted = true;

    void import("@/components/index/sections/hero/PortfolioHomePage").then((module) => {
      if (isMounted) {
        setPreview(() => module.PortfolioPreview);
      }
    });

    return () => {
      isMounted = false;
    };
  }, []);

  return (
    <div>
      {Preview ? (
        <Preview {...props} />
      ) : (
        <Skeleton className="min-h-[32rem] w-full rounded-2xl !bg-softiq-secondary-shade-100/50" />
      )}
    </div>
  );
}
